import { render, staticRenderFns } from "./VStatus.vue?vue&type=template&id=332223ce&scoped=true"
import script from "./VStatus.vue?vue&type=script&lang=js"
export * from "./VStatus.vue?vue&type=script&lang=js"
import style0 from "./VStatus.vue?vue&type=style&index=0&id=332223ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332223ce",
  null
  
)

export default component.exports